import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getTicketSalesInput,
  getTicketSaleInput,
  TicketSaleLiteModel,
  TicketSaleModel,
} from './model';

export function useGetTicketSales(
  input?: getTicketSalesInput,
  options?: UseQueryOptions<ExtendedApiResult<TicketSaleLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<TicketSaleLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getTicketSales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'flight-sales',
          params: input?.params,
        }),
      options,
    ),
    TicketSaleLiteModel,
  );
}

export function useGetTicketSale(
  input?: getTicketSaleInput,
  options?: UseQueryOptions<ApiResult<TicketSaleModel>, ApiError>,
): UseQueryResult<ApiResult<TicketSaleModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getTicketSale', input?.id],
      () => QueryFetchFunction({ url: `flight-sales/${input?.id}` }),
      options,
    ),
    TicketSaleModel,
  );
}

export function getTicketSalesKey(input?: getTicketSalesInput) {
  return ['getTicketSales', input?.params];
}

export function getTicketSaleKey(input?: getTicketSaleInput) {
  return ['getTicketSale', input?.id];
}
